import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { useBoardSeatCounts } from '@src/components/sco/Advisors/hooks/useBoardSeatCounts';
import { AdvisorsSubNavLayout } from '@src/components/sco/Advisors/layout/AdvisorsSubNavLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { seatsNavItems, SeatsSectionKey } from '@src/components/sco/Advisors/utils/seatsNav';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ReactNode } from 'react';
import { LuPlus } from 'react-icons/lu';

/**
 * My Advisors shell — status sub-nav rail plus section content.
 * "Add a board seat" sits in the rail footer so it is reachable from any view.
 */
export const BoardSeatsLayout = t0 => {
  const $ = _c(16);
  const {
    activeKey,
    title,
    description,
    action,
    children
  } = t0;
  const paths = useAdvisorsPaths();
  const {
    counts
  } = useBoardSeatCounts();
  const navItems = seatsNavItems(paths);
  let t1;
  if ($[0] !== activeKey) {
    t1 = item => item.key === activeKey;
    $[0] = activeKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeItem = navItems.find(t1);
  useAdvisorsToolbar({
    breadcrumbs: activeKey === "board" ? advisorsBreadcrumbsWithTrail({
      title: "My Advisors",
      href: paths.myAdvisors
    }) : advisorsBreadcrumbsWithTrail({
      title: "My Advisors",
      href: paths.myAdvisors
    }, {
      title: activeItem?.title ?? "My Advisors",
      href: activeItem?.href ?? paths.myAdvisors
    })
  });
  const T0 = AdvisorsSubNavLayout;
  const t2 = "Everyone you own \u2014 on the board, invited, searching, or still a draft.";
  const t3 = "My Advisors";
  let t4;
  if ($[2] !== counts) {
    t4 = item_0 => ({
      key: item_0.key,
      title: item_0.title,
      href: item_0.href,
      icon: item_0.icon,
      count: counts[item_0.countKey]
    });
    $[2] = counts;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = navItems.map(t4);
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LuPlus />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== paths.seatNew) {
    t7 = <Button asChild={true} size="sm" variant="cta" width="full"><NextLink href={paths.seatNew}>{t6} Add a board seat</NextLink></Button>;
    $[5] = paths.seatNew;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== T0 || $[8] !== action || $[9] !== activeKey || $[10] !== children || $[11] !== description || $[12] !== t5 || $[13] !== t7 || $[14] !== title) {
    t8 = <T0 action={action} activeKey={activeKey} description={description} railDescription={t2} railTitle={t3} title={title} items={t5} railFooter={t7}>{children}</T0>;
    $[7] = T0;
    $[8] = action;
    $[9] = activeKey;
    $[10] = children;
    $[11] = description;
    $[12] = t5;
    $[13] = t7;
    $[14] = title;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};